<template>
    <div class="tommSystem">
        <div class="banner_box col_fff">
            <div class="youhua">
                <div class="title-text">终端运维管理</div>
                <div class="text-box">
                    采用物联网技术，对终端进行智能运维管理，支持快速、分区、个性化部署；不同硬件外设的开放不同的功能；按型号、指定终端进行统一或者个性化应用设置，能实时监控终端运行状态、硬件状态、耗材状态，并提供异常警告功能。
                </div>
            </div>
        </div>
        <div class="container_box2 center">
            <div class="f_34 col_2C353E">功能概要</div>
            <div class="bottom-border">
                <div class="bottom-border-box"></div>
            </div>
            <div class="content-one">
                <div v-for="(item, index) in contentone" :key="index" class="for-in">
                    <div class="imgs">
                        <img :src="item.imgurl" alt="">
                    </div>
                    <div class="titles">{{ item.titles }}</div>
                    <div class="texts">{{ item.texts }}</div>
                </div>
            </div>
        </div>
        <div class="content-two">
            <div class="f_34 col_2C353E">系统展示</div>
            <div class="bottom-border">
                <div class="bottom-border-box"></div>
            </div>
            <div class="title-ps">
                对自助终端进行统一的运维管理：自助终端信息维护；分区、分型号快速部署；定时开关机；远程维护；远程关机；屏幕快照获取；耗材监控；耗材更新记录；异常告警；事件记录；事件处理流程管理；基础信息维护等</div>
            <div class="system-img">
                <img src="../../assets/img/digitalOperation/tommSystem/page.png" alt="">
            </div>
        </div>
        <div class="content-three">
            <div class="f_34 col_2C353E">移动端展示</div>
            <div class="bottom-border">
                <div class="bottom-border-box"></div>
            </div>
            <div class="title-ps">自助终端信息查询；配置管理；耗材监控；耗材更新记录；事件记录及处理；基础信息维护等</div>
            <div class="system-img">
                <img src="../../assets/img/digitalOperation/tommSystem/mobile-page.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "tommSystem",
    data() {
        return {
            contentone: [
                {
                    imgurl: require('../../assets/img/digitalOperation/tommSystem/simple.png'),
                    titles: '易上手',
                    texts: '做到前后端分离，简化移动端用户使用流程与步骤，极大提高用户使用速度。',
                },
                {
                    imgurl: require('../../assets/img/digitalOperation/tommSystem/adapter.png'),
                    titles: '适配度高',
                    texts: '对市场上多家移动端设备进行调研，并产出对应的适配文档，产品对于不同移动端适配度高，容错率小。',
                },
                {
                    imgurl: require('../../assets/img/digitalOperation/tommSystem/deployment.png'),
                    titles: '部署实施随需而变',
                    texts: '基于云计算的设计理念，模块松耦合化，根据客户不同的建设目标系统部署随需而变。',
                },
            ],
        }
    }
}
</script>

<style scoped lang="scss">
.tommSystem {
    .banner_box {
        width: 100%;
        background-image: url("../../assets/img/digitalOperation/tommSystem/zdyw-banner.png");
        background-size: 1920px 498px;
        background-repeat: no-repeat;
        background-position: bottom;
        padding-top: 162px;
        padding-bottom: 167px;

        .youhua {
            width: 1200px;
            margin: auto;
        }

        .title-text {
            width: 400px;
            font-size: 60px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
        }

        .text-box {
            margin-top: 50px;
            width: 678px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 24px;
        }
    }

    .container_box2 {
        padding-top: 79px;
    }

    .bottom-border {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .bottom-border-box {
        width: 50px;
        height: 4px;
        background-color: #2E7AF5;
        margin-top: 20px;
    }

    .content-one {
        width: 1200px;
        margin: auto;
        display: flex;
        justify-content: space-between;

        .for-in {
            width: 240px;
            height: 380px;

            .imgs {
                width: 80px;
                height: 80px;
                margin-top: 71px;
                margin-left: auto;
                margin-right: auto;
            }

            .titles {
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #2C353E;
                text-align: center;
                // line-height: 34px;
                margin: 30px 0;
            }

            .texts {
                width: 240px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #818A95;
                line-height: 22px;
                text-align: left;
            }
        }
    }

    .content-two {
        background: #F6F7F9;
        text-align: center;
        padding-top: 80px;
        padding-bottom: 80px;

        .title-ps {
            margin-top: 40px;
            margin-left: auto;
            margin-right: auto;
            width: 1200px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #818A95;
            line-height: 25px;
        }

        .system-img {
            width: 1200px;
            height: 100%;
            margin-top: 40px;
            margin-left: auto;
            margin-right: auto;

            img {
                width: 1200px;
            }
        }
    }

    .content-three {
        // background: #F6F7F9;
        text-align: center;
        padding-top: 80px;
        padding-bottom: 80px;

        .title-ps {
            margin-top: 40px;
            margin-left: auto;
            margin-right: auto;
            width: 1200px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #818A95;
            line-height: 25px;
        }

        .system-img {
            width: 1200px;
            height: 100%;
            margin-top: 40px;
            margin-left: auto;
            margin-right: auto;

            img {
                width: 1200px;
            }
        }
    }
}
</style>
